import React from 'react';
import { Formik, Form } from 'formik';
import {
  IonPage,
  IonContent,
  IonButton,
  IonCard,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol
} from '@ionic/react';
import Field from 'src/components/Field';
import WithRecord from 'src/components/WithRecord';
import DefaultHeader from 'src/components/DefaultHeader';
import app from 'src/feathers';
import alerts from 'src/lib/alerts';

class Profile extends React.Component {
  handleSubmit = async (data, formik) => {
    await app
      .service('api/users')
      .patch(null, data)
      .then((data) => {
        formik.resetForm(data);
        alerts.success('Account updated!');
      })
      .catch((error) => {
        if (error.errors) {
          formik.setErrors(error.errors);
        }
        alerts.errors(error);
        formik.setSubmitting(false);
      });
  };

  render() {
    const { user } = this.props;
    return (
      <IonPage>
        <DefaultHeader title="My Profile" />
        <IonContent>
          <IonGrid fixed>
            <IonRow>
              <IonCol sizeLg="6" offsetLg="3">
                <IonCard className="ion-no-margin">
                  <IonCardContent>
                    <Formik
                      initialValues={user}
                      onSubmit={this.handleSubmit}
                      validationSchema={app.service('api/users').schema}
                      render={({ isSubmitting }) => (
                        <Form>
                          <Field
                            label="First Name"
                            name="first_name"
                            disabled={isSubmitting}
                          />
                          <Field
                            label="Last Name"
                            name="last_name"
                            disabled={isSubmitting}
                          />
                          <Field
                            label="Email"
                            name="email"
                            disabled={isSubmitting}
                          />
                          <Field
                            label="Phone"
                            name="phone"
                            disabled={isSubmitting}
                          />
                          <IonButton
                            expand="block"
                            disabled={isSubmitting}
                            type="submit"
                          >
                            Save
                          </IonButton>
                        </Form>
                      )}
                    />
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
      </IonPage>
    );
  }
}

export default (routerProps) => {
  return (
    <WithRecord
      useLifecycle={true}
      service="api/users"
      _id={null}
      render={({ record }) => {
        return <Profile user={record} {...routerProps} />;
      }}
    />
  );
};
